import { Component, Input } from "@angular/core";
import { ControlValueAccessor } from "@angular/forms";

@Component({
  selector: 'cosmos-select',
  templateUrl: './select.component.html',
  styles: ["@import '~@angular/cdk/overlay-prebuilt.css';", "*{ border: solid 1px black; }"],
})
export class CosmosSelectComponent implements ControlValueAccessor {
  public isOpen = false; // necessary for overlay to know if should be visible or not, afaik cannot be moved to template html
  private _selected = 0;
  private _onChange?: (_: any) => void;

  private _values?: any[];

  public static make(arg0: any[]) {
    const comp = new CosmosSelectComponent();
    comp.values = arg0;
    return comp;
  }

  public constructor() { }

  public writeValue(obj: any): void {
    const val = Number(obj);
    if (val === NaN) {
      throw new Error(`An number must be provided, you provided ${obj}`);
    }
    this.select(val);
  }

  public registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    throw new Error("Method not implemented.");
  }

  @Input() public set values(values: any[] | undefined) {
    this._values = values;
    this.valuesCheck();
  }

  public get values() {
    this.valuesCheck();
    return this._values;
  }

  public select(index: number) {
    this.valuesCheck();
    if (0 > index || index > this._values!.length) {
      throw new Error("Cannot select from outside provided list");
    }
    this._selected = index;
    this._onChange?.(index);
  }

  public get value() {
    this.valuesCheck();
    return this._values![this._selected];
  }

  /**
   * Checks if _values has been set and are meet assumptions
   */
  private valuesCheck() {
    if (!this._values) {
      throw new Error("You must supply values first");
    }
    if (this._values.length === 0) {
      throw new Error("Supplied options must not be empty");
    }
  }
}
